<template>
  <transition-group
    class="meeting-types-and-address"
    name="meeting-types-and-address"
    tag="div"
  >
    <span v-if="availableMeetingTypesText" :key="availableMeetingTypesText"
      >{{ availableViaText }} {{ availableMeetingTypesText }}</span
    >
    <span v-if="locationText" :key="locationText"
      >{{ basedInText }} <strong v-text="locationText"
    /></span>
  </transition-group>
</template>

<script>
import { useCurrentSite } from 'Composables/useCurrentSite';
import { getThemeText } from 'Constants/themeVars';
import {
  hasLawyerRole,
  hasTherapyRole,
  meetingTypeBucketForRole,
} from 'Main/contact-form/constants';
import { mapState } from 'vuex';

export default {

  computed: {
    ...mapState('user', ['availableMeetingTypes', 'address']),

    availableMeetingTypesText() {
      const meetingTypeValues = Object.values(this.meetingTypes).map((value) =>
        value.toLowerCase()
      );

      if (meetingTypeValues.length === 0) return '';
      if (meetingTypeValues.length === 1) return meetingTypeValues[0];
      if (meetingTypeValues.length === 2)
        return `${meetingTypeValues[0]} & ${meetingTypeValues[1]}`;

      const lastItem = meetingTypeValues.pop();
      return `${meetingTypeValues.join(', ')} & ${lastItem}`;
    },

    locationText() {
      if (!hasTherapyRole(this.role) && !hasLawyerRole(this.role)) {
        return '';
      }

      if (!this.address) {
        return '';
      }

      const { city, postcode } = this.address;

      if (!city) {
        return '';
      }

      if (this.currentSite === 'GB' && postcode) {
        return `${city}, ${postcode}`;
      }

      return city;
    },

    meetingTypes() {
      return this.availableMeetingTypes[meetingTypeBucketForRole(this.role)];
    },
  },

  data() {
    return {
      availableViaText: getThemeText(
        'counselorGridTexts.availableVia',
        'Available via'
      ),
      basedInText: getThemeText('counselorGridTexts.basedIn', 'Based in'),
      role: this.$root.$data.role,
    };
  },
  name: 'MeetingTypesAndAddress',

  setup() {
    const { currentSiteUpperCase } = useCurrentSite();
    return { currentSite: currentSiteUpperCase };
  },
};
</script>
